import { capitalize } from 'es-toolkit';
import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';

import getApplicationPackagesLengthSelector from '/business/shared/state/selectors/applications/getApplicationPackagesLengthSelector';

import StyledHeaderWelcome from '/business/shared/components/widgets/header/__styled__/StyledHeaderWelcome';
import type { RootState } from '/business/shared/state/store';

function HeaderDashboardWelcome() {
  const userFirstName = useSelector((state: RootState) => state.auth?.user?.account?.metadata?.firstName ?? '');
  const numberOfApplications = useSelector(getApplicationPackagesLengthSelector);
  const firstName = capitalize(userFirstName);

  return (
    <StyledHeaderWelcome>
      <h1>
        {/* @i18n: Welcome Alex */}
        <Trans i18nKey="business:Dashboard.welcomeText" values={{ firstName }} components={{ 1: <strong /> }} />
      </h1>
      <p>
        {/* @i18n: You are viewing 3 carbon reviews */}
        <Trans
          i18nKey="business:Dashboard.applicationViewingCount"
          count={numberOfApplications}
          values={{ count: numberOfApplications }}
          components={{ 1: <strong /> }}
        />
      </p>
    </StyledHeaderWelcome>
  );
}

export default HeaderDashboardWelcome;
